import theme from 'App.theme';
import { ComponentProps } from 'react';
import { TurnaroundPageVariant } from '../models';

export const TURNAROUND_CARD_HEADER_HEIGHT = 40;

type Props = {
  variant: TurnaroundPageVariant;
  title: string;
} & ComponentProps<'div'>;

export const TurnaroundCard = ({ variant, title, children, style, ...props }: Props) => {
  return (
    <div
      style={{
        border: `1px solid ${theme.greys.GREYA2}`,
        backgroundColor: theme.colors.white,
        display: 'flex',
        flexDirection: 'column',
        padding: theme.layout.spacing.tiny,
        ...style,
      }}
      {...props}
    >
      <div
        style={{
          border: `1px solid ${theme.greys.GREYA2}`,
          backgroundColor: variant === 'origin' ? theme.colors.primaryLight : theme.colors.amberLight,
          padding: theme.layout.spacing.small,
          minHeight: TURNAROUND_CARD_HEADER_HEIGHT,
        }}
      >
        <div
          style={{
            fontSize: 14,
            lineHeight: '22px',
            fontWeight: 500,
            color: theme.colors.black,
          }}
        >
          {title}
        </div>
      </div>

      {children}
    </div>
  );
};
